import React from 'react';
import { Copy, Pencil, Plus, Trash2 } from '../bravosIcons';

/** Block reorder handle — canonical size (iOS-aligned standardization pick A). */
export function DragHandleBlock() {
  return (
    <svg width="14" height="20" viewBox="0 0 14 20" fill="currentColor" aria-hidden>
      <circle cx="3" cy="3" r="1.5" />
      <circle cx="11" cy="3" r="1.5" />
      <circle cx="3" cy="10" r="1.5" />
      <circle cx="11" cy="10" r="1.5" />
      <circle cx="3" cy="17" r="1.5" />
      <circle cx="11" cy="17" r="1.5" />
    </svg>
  );
}

/** Same glyph as DragHandleBlock (standardized to A). */
export function DragHandleExercise() {
  return <DragHandleBlock />;
}

/** Same glyph as DragHandleBlock (standardized to A). */
export function StepDragDots() {
  return <DragHandleBlock />;
}

export function FieldEditIcon() {
  return <Pencil className="field-edit-icon" width={14} height={14} aria-hidden />;
}

export function NoteEditIcon() {
  return <Pencil className="note-edit-icon" width={13} height={13} aria-hidden />;
}

export function IconTrash({ size = 14 }: { size?: number }) {
  return <Trash2 width={size} height={size} aria-hidden />;
}

export function IconCopy({ size = 14 }: { size?: number }) {
  return <Copy width={size} height={size} aria-hidden />;
}

export function IconPlus({ size = 12 }: { size?: number }) {
  return <Plus width={size} height={size} aria-hidden />;
}

export function IconMinusRow() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}
